import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Modal from '../../molecules/Modal';
import MoneyInputItem from '../../molecules/MoneyInputItem';
import InputItem from '../../molecules/InputItem';
import Paragraph from '../../atoms/Paragraph';
import Flex from '../../atoms/Flex';
import Button from '../../atoms/Button';
import { useForm } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import TextareaItem from '../../molecules/TextareaItem';
import { useTheme } from 'styled-components';
import { getAppThemeName } from '../../../services/appTheme';
const ReportAmountModal = ({ open, dossierNumber, setReportModalOpen, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { post, data, setData, errors, reset, processing } = useForm({
        amount: '',
        description: '',
        receipt_date: '',
    });
    const handleSubmit = (e) => {
        e.preventDefault();
        post(`/dossier/${dossierNumber}/betaling-melden`, {
            preserveScroll: true,
            onSuccess: () => {
                reset();
                setReportModalOpen(false);
            },
        });
    };
    const handleClose = () => {
        setReportModalOpen(false);
        reset();
    };
    const handleChange = (e) => {
        // @ts-ignore
        setData(e.target.name, e.target.value, e.target.receipt_date);
    };
    return (_jsxs(Modal, { title: t('report_payment.title'), open: open, onClose: handleClose, children: [_jsxs(Paragraph, { children: [" ", t('report_payment.paragraph'), " "] }), _jsx("form", { onSubmit: handleSubmit, children: _jsxs(Flex, { column: true, children: [_jsx(MoneyInputItem, { label: t('report_payment.amount'), placeholder: "0,00", value: data.amount, onChange: handleChange, name: 'amount', disabled: processing, error: errors.amount, type: "number", required: true }), getAppThemeName() === 'invoned' && (_jsx(InputItem, { type: "date", label: t('report_payment.receipt_date'), error: errors.receipt_date, disabled: processing, name: 'receipt_date', required: true, onChange: handleChange })), _jsx(TextareaItem, { fullWidth: true, label: t('report_payment.description'), placeholder: t('report_payment.description_placeholder'), value: data.description, name: 'description', disabled: processing, error: errors.description, onChange: handleChange }), _jsx(Button, { secondary: true, isLoading: processing, type: "submit", textAlign: "center", 
                            //@ts-ignore
                            loaderColor: theme.primary.dark, children: t('report_payment.submit') })] }) })] }));
};
export default ReportAmountModal;
